<template>
    <v-card outlined :loading="loading" :key="keyIndex + 'package-card-room-child'" class="px-0 mx-0">
        <template slot="progress">
            <v-progress-linear color="deep-purple" height="10" indeterminate></v-progress-linear>
        </template>

        <v-card-title class="mb-1 pb-1 blue--text text--darken-3">
            {{ RoomRate.hotDealName }}
        </v-card-title>

        <v-card-text class="mb-1">
            <v-row class="mx-0" no-gutters>
                <v-col md="4">
                    <v-carousel hide-delimiters height="250" width="320">
                        <v-carousel-item v-if="RoomRate.roomImages.length !== 0"
                            v-for="(item, i) in RoomRate.roomImages" :key="i" :src="item.urlImage"
                            reverse-transition="fade-transition" transition="fade-transition" height="250"
                            width="320"></v-carousel-item>

                        <v-carousel-item v-if="RoomRate.roomImages.length === 0">
                            <v-sheet color="gray" height="100%">
                                <v-row class="fill-height" align="center" justify="center">
                                    <div class="text-h2">
                                        No Image
                                    </div>
                                </v-row>
                            </v-sheet>
                        </v-carousel-item>
                    </v-carousel>
                </v-col>

                <v-col md="8">
                    <v-row no-gutters>
                        <v-col class="mx-2 px-2">
                            <div>{{ hotDealDescription }}</div>
                        </v-col>
                        <v-col>
                            <div class="d-flex justify-center text-subtitle-2 font-weight-black">
                                Start From
                            </div>

                            <div class="d-flex justify-center text-h6 teal--text text--darken-1">
                                <strong>{{ RoomRate.roomRatePlans[0].displayTotalPrice }}</strong>
                            </div>
                            <div v-if="RoomRate.roomRatePlans[0].displayOriginalPrice !== RoomRate.roomRatePlans[0].displayTotalPrice"
                                class="d-flex justify-center text-subtitle-2 font-weight-black text-decoration-line-through deep-orange--text text--darken-2">
                                <strong>{{ RoomRate.roomRatePlans[0].displayOriginalPrice }}</strong>
                            </div>
                            <div class="d-flex justify-center ">
                                Price for {{ RoomRate.roomRatePlans[0].priceList.length }} night(s)
                            </div>

                            <template v-if="RoomRate.roomRatePlans[0].promotionType !== 'None'">
                                <div class="d-flex justify-center text-h6">
                                    <v-icon class="red--text darken-2">mdi-star</v-icon> Promotion
                                </div>
                            </template>
                            <!-- <div class="d-flex justify-center text-h6">
                                <v-icon class="red--text darken-2">mdi-gift</v-icon> Package Deal
                            </div> -->


                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card-text>

        <!-- <v-divider class="mx-4"></v-divider> -->

        <!-- <v-card-title>Unit</v-card-title> -->

        <!-- <v-card-text>
  
        <v-select v-model="selectedUnit" :items="numberOfUnits" solo> </v-select>
      </v-card-text> -->

        <!-- <v-card-actions class="mt-0 pt-0 text-subtitle-2">
            <v-list min-width="100%">
                <v-list-item>
                    <v-row no-gutters>
                        <v-col>
                            <v-icon>mdi-account</v-icon>
                        </v-col>
                        <v-col>Rate Plan</v-col>
                        <v-col class="d-flex justify-center">Rates</v-col>
                        <v-col class="d-flex justify-center">
                            Room Available
                        </v-col>
                        <v-col class="d-flex justify-center">
                            Package Details
                        </v-col>
                        <v-col>
                        </v-col>
                    </v-row>
                </v-list-item>
                <template v-for="(ratePlan, iratePlan) in RoomRate.roomRatePlans">
                    <v-list-item :key="'vlist' + iratePlan">
                        <rate-plan :IsPackage="true" :Occupancy="numberOfUnits(ratePlan.room.availability)"
                            :RatePlan="ratePlan" :Room="RoomRate"></rate-plan>
                    </v-list-item>
                    <v-divider :key="'divider' + iratePlan"></v-divider>
                </template>

            </v-list>
        </v-card-actions> -->

        <template v-for="(ratePlan, iratePlan) in RoomRate.roomRatePlans.filter(g => g.groupTag == 1)">
            <rate-plan :IsPackage="true" :Occupancy="numberOfUnits(ratePlan.room.availability)" :RatePlan="ratePlan"
                :key="iratePlan + 'package-rate-plan-card-group-1'" :Room="RoomRate"></rate-plan>
        </template>

        <div v-if="RoomRate.roomRatePlans.filter(g => g.groupTag == 2 || g.groupTag == 3).length > 0">
            <v-sheet class="p-0 py-0 rate-plan-card-border rounded-b">
                <v-col class="d-flex justify-center text-decoration-none footer-link-hover" style="font-weight: 400;">
                    <v-sheet outlined :id="`package-other-rates-content-${keyIndex}`"
                        @click="onClickSeeOtherRates(keyIndex)" height="40" width="300"
                        class="d-flex align-center justify-center view-rates-border">
                        See more deals outside of selected dates <v-icon
                            :id="`package-other-rates-content-icon-${keyIndex}`"
                            class="mdi mdi-chevron-right text-center" small></v-icon>
                    </v-sheet>
                </v-col>
            </v-sheet>

            <div style="display: none;" :id="`package-rate-plan-card-group-2n3-${keyIndex}`">
                <template
                    v-for="(ratePlan, iratePlan) in RoomRate.roomRatePlans.filter(g => g.groupTag == 2 || g.groupTag == 3)">
                    <rate-plan :Occupancy="numberOfUnits(ratePlan.room.availability)" :RatePlan="ratePlan"
                        :key="iratePlan + 'package-rate-plan-card-group-2&3'" :Room="RoomRate"></rate-plan>
                </template>
            </div>


        </div>
    </v-card>
</template>

<script>
import moment from "moment";
import RatePlan from "./RatePlanCard.vue";
export default {
    props: {
        RoomRate: {
            type: Object,
            require: true,
        },
        keyIndex: {
            type: String,
            required: true
        }
    },
    components: {
        RatePlan
    },
    data: () => ({
        loading: false,
        selection: 1,
        items: [],
        selectedUnit: 1,
        dialog: false,
    }),

    methods: {
        formatDate(date) {
            return moment(date).format("dddd Do MMMM");
        },
        numberOfUnits: function (availability) {
            let occupancy = availability;
            let list = [];
            for (let counter = 1; counter <= occupancy; counter++) {
                list.push({ text: `${counter} Unit`, value: counter });
            }

            return list;
        },
        onClickSeeOtherRates(value) {


            // Access the element with ID 'rate-plan-card-group-2-3'
            const ratePlanGroup = document.getElementById(`package-rate-plan-card-group-2n3-${value}`);

            // Toggle visibility or manipulate its style as needed
            if (ratePlanGroup) {
                ratePlanGroup.style.display = ratePlanGroup.style.display === 'none' ? 'block' : 'none';
            }
            const otherRateContent = document.getElementById(`package-other-rates-content-icon-${value}`);

            if (otherRateContent.classList.contains('mdi-chevron-down')) {
                otherRateContent.classList.remove('mdi-chevron-down');
                otherRateContent.classList.add('mdi-chevron-right');
            } else if (otherRateContent.classList.contains('mdi-chevron-right')) {
                otherRateContent.classList.remove('mdi-chevron-right');
                otherRateContent.classList.add('mdi-chevron-down');
            }

            // // Check if it contains "See Other Rates" text
            // if (otherRateContent) {
            //     const isSeeOtherRates = otherRateContent.innerText.includes('View More Rates');

            //     // Update the HTML content with icons
            //     otherRateContent.innerHTML = isSeeOtherRates
            //         ? "View Less Rates <v-icon class='mdi mdi-chevron-down'></v-icon>"
            //         : "View More Rates <v-icon class='mdi mdi-chevron-right'></v-icon>";
            // }

            // // Toggle the class for smooth animation
            // if (otherRateContent) {
            //     otherRateContent.classList.toggle('show-content');
            // }

        }
    },
    computed: {
        hotDealName: function () {
            let name = this.RoomRate.hotDealName;
            // let name = this.RoomRate.priceList[0].hotDealName;
            return name;
        },
        hotDealDescription: function () {
            let name = this.RoomRate.hotDealDescription;
            // let name = this.RoomRate.priceList[0].hotDealDescription;
            return name;
        },

    },
};
</script>